const orgFeesInvoiceStrings = {
  pageTitle: "Fakturagrunnlag",
  exportButton: "Eksporter til CSV",
  notFoundWarning: "Fant ingen krav for perioden"
};

export default orgFeesInvoiceStrings;